import { render, staticRenderFns } from "./EqsMultiAvatars.vue?vue&type=template&id=0a84faaa"
import script from "./EqsMultiAvatars.vue?vue&type=script&lang=js"
export * from "./EqsMultiAvatars.vue?vue&type=script&lang=js"
import style0 from "./EqsMultiAvatars.vue?vue&type=style&index=0&id=0a84faaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports